export default __webpack_public_path__ + "static/media/project.a3648d38.png";